export default __webpack_public_path__ + "static/media/startups_software.a18a99ca.svg";